var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowAllStages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 20,
    height: 40,
    viewBox: "0 0 20 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1821 1.24149C16.8936 0.396597 18.1553 0.288452 19.0002 0.999944C19.8451 1.71144 19.9532 2.97314 19.2417 3.81804L5.61486 19.9999L19.2417 36.1818C19.9532 37.0267 19.8451 38.2885 19.0002 38.9999C18.1553 39.7114 16.8936 39.6033 16.1821 38.7584L0.385494 19.9999L16.1821 1.24149Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAllStages);
export default __webpack_public_path__ + "static/media/arrow_all_stages.39ef98e7.svg";
export { ForwardRef as ReactComponent };